import { EventEmitter, Injectable } from "@angular/core";
import { take, timeout } from "rxjs/operators";

declare const getToggle;

declare global {
  interface Window {
    responseToggle: (data: any) => any;
    webkit: any;
    JSBridge: any;
  }
}

@Injectable({ providedIn: "root" })
export class DeviceInfoNativeService {

  constructor() {
    window.responseToggle = (data: string) => {
      localStorage.setItem("getToggle", JSON.stringify(data));
      console.log("CONSOLE responseToggle constructor", data);
    };
  }

  getItemCommunicator(): void {
    /**
     * Send mensage for IOS or Android
     */
    if (
      window.webkit &&
      window.webkit.messageHandlers &&
      window.webkit.messageHandlers.getToggle
    ) {
      this.comunicationIOS();
    } else {
      this.comunicationAndroid();
    }
  }

  private comunicationIOS() {
    const paramsValue = {
      key: "onboarding_rlp_exibir_tela",
    };
    window.webkit.messageHandlers.getToggle.postMessage(paramsValue);
  }
  private comunicationAndroid() {
    try {
      const paramsValue = JSON.stringify({ key: "onboarding_rlp_exibir_tela" });
      getToggle.postMessage(paramsValue);
    } catch (error) {}
  }
}
